
<template>
    <v-card>
        <v-toolbar dark flat color="secondary">
            <v-toolbar-title :style="$store.state.textFormatting.headers"> {{message}}
                <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                        <small v-on="on" :style="$store.state.textFormatting.main"> (select row to filter alerts) </small>         
                    </template>
                    <span :style="$store.state.textFormatting.main">(select row to filter alerts)</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-progress-circular v-if="loading" indeterminate color="white"> </v-progress-circular>

            <v-spacer></v-spacer>

            <v-tooltip top color="secondary" id="top10back10" >
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="asnNuserINfo('refresh')" fab small v-if="!loading"  icon>
                        <v-icon :style="$store.state.textFormatting.main"> refresh 
                        </v-icon> 
                    </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Refresh ASN information</span>
            </v-tooltip>

            <v-menu open-on-hover>
                <template v-slot:activator="{ on }">
                    <v-btn outline v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> {{ hoursback }} Hours back</h4> </v-toolbar-title> </v-btn>
                </template>
                <v-list v-for="(i, key) in orderByList" :key="key">
                    <v-list-tile @click="refreshList(i.param)">
                        <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            
            <v-flex shrink class="px-1">
                <v-tooltip top eager close-delay=500 >
                    <template v-slot:activator="{ on }">
                        <v-toolbar-title v-on="on">
                            <small>
                                <small :style="$store.state.textFormatting.main">
                                    {{ updatedStr }} 
                                </small>
                            </small>
                        </v-toolbar-title>
                    </template>
                    <span :style="$store.state.textFormatting.main"> {{ updatedStr }} </span>
                </v-tooltip>
            </v-flex>
            
            <v-btn @click="showTheBlock=!showTheBlock" class="mx-2" small fab color="blue" dark v-if="showTheBlock"> <h2> - </h2> </v-btn>
            <v-btn @click="showTheBlock=!showTheBlock" class="mx-2" small fab color="blue" dark v-if="!showTheBlock"> <h2> + </h2> </v-btn>
            <info>
                <template>Organisation AS List</template>
                <template slot="body"> 
                    <p> A list of all organisation ASNs and the number of notifications for the last day, split in to categories (hover the header for explanation)</p>
                    <br>
                    <p> Click any row to see alerts for the given ASN (limited to <b>2000</b> alerts)</p>
                </template>
                <template slot="action">
                    <v-btn flat color="primary" to="/searchEvents" :style="$store.state.textFormatting.main"> SEARCH ALERTS </v-btn> 
                </template>
                
            </info>
        </v-toolbar>
        <v-layout column justify-space-around v-if="showTheBlock">
            <v-flex v-if="!loading">
                <v-data-table :headers="headers" :items="data" :key="id" item-key="ASN"
                :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                    <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                        <span slot="activator" :style="$store.state.textFormatting.main">
                            {{ props.header.text }}
                        </span>
                        <span :style="$store.state.textFormatting.main">
                            {{ props.header.ad_text }}
                        </span>
                        </v-tooltip>
                    </template>  
                    <template slot="items" slot-scope="props" >
                        <tr  @click="SelectASN(props.item.asn); clickHandle()">
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b></div>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.asn] }}</span>
                                </v-tooltip>
                                <div v-if="!is_asn_owners" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b> <v-progress-circular size="12" indeterminate color="purple" /></div>
                            </td>
                            <td class="text-xs-left special" :style="$store.state.textFormatting.main"> 
                                <span v-if="props.item.asn_name">{{ props.item.asn_name }}</span>
                                <span v-if="!props.item.asn_name">
                                    <span v-if="!is_asn_owners" :style="$store.state.textFormatting.main"><v-progress-circular size="12" indeterminate color="purple" /></span>
                                    <span v-if="is_asn_owners" :style="$store.state.textFormatting.main">{{ asn_own_dict[props.item.asn] }}</span>
                                </span>
                            </td>
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main"> <v-progress-circular indeterminate color="purple" v-if="props.item.loading"> </v-progress-circular> <div v-if="!props.item.loading" :style="$store.state.textFormatting.main">{{ props.item.event_count }}</div></td>
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.count }}</td>
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main"> 
                                <span v-if="props.item.show_ownership_assertion" > {{ props.item.ownership_assertion }} </span>
                                <span v-if="!props.item.show_ownership_assertion" > #N/A </span>
                            </td>
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main"> 
                                <span v-if="props.item.show_path_change" > {{ props.item.path_change }} </span>
                                <span v-if="!props.item.show_path_change" > #N/A </span>
                            </td>
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main"> 
                                <span v-if="props.item.show_first_seen" > {{ props.item.first_seen }} </span>
                                <span v-if="!props.item.show_first_seen" > #N/A </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>

//import { Auth } from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';
//import { AmplifyEventBus } from 'aws-amplify-vue';
import info from './infopopout.vue'


export default {
    name: 'asn-list-threshold',
    props: ['type', 'refresh'],
    components: {
        info
    },
    data () {
        return {
            showTheBlock: true,
            headers: [
            { text: 'ASN', value:'asn', ad_text: "ASN of interest"},
            { text: 'Alert Rule Name', value:'asn_name', ad_text: "ASN of interest"},
            { text: 'Event Count (24H)', value:'event_count', ad_text: "Event count over the given period of time (may be less than alert count due to retrospective calculation)"},
            { text: 'Alert Count (24H)', value:'count', ad_text: "Alert count over given period of time for this organisation's ASNs"},
            //{ text: 'Hijack', value:'Hijack', align:'left', sortable: false},
            //{ text: 'Impact', value:'Impact', align:'left', sortable: false },
            //{ text: 'Validation', value:'Validation', align:'left', sortable: false },
            { text: 'Own. Assertions', value: 'ownership_assertion', ad_text:'Alerts where the origin ASN has changed from one to another'},
            { text: 'Path Change', value: 'path_change', ad_text:"Alerts where the origin ASN hasn't changed"},
            { text: 'First Seen', value: 'first_seen', ad_text:"Alerts where the prefix has no owner prior to the alert occuring"},
            
            ],
            data: [],
            rowsPerPageItems: [20, 30, 40, 50],
            orderByList: [
                {name: "6h", param: "6"},
                {name: "12h", param: "12"},
                {name: "24h", param: "24"},
                {name: "48h", param: "48"},
                {name: "72h", param: "72"}
            ],
            pagination: {
                rowsPerPage: 10
                },
            message: "Loading...",
            hoursback: 24,
            id: 0,
            childASN: null,
            loading: false,
            updatedStr: "",
            asn_own_dict: {},
            asn_get_owner: [],
            is_asn_owners: false,
            organisation: ''
        }
    },
    
    beforeMount() {
        try {
            this.organisation = this.$store.state.user.organisation;
            //this.username = this.$store.state.user.username;
        } catch (err) {
            console.log(err)
            location.reload()
        }
        
        this.asnNuserINfo();
        this.showTheBlock = this.$store.state.showSettings.showOrgASNSummary;
    },
    mounted() {
        
    },
    methods: {
        SelectASN: function (i) {
            this.childASN = i
        },
        clickHandle: function () {
            this.$emit('passChildASN',  this.childASN, this.hoursback)
        },
        getAnASNOwner: async function(asn) {
            if (asn == 0) {
                return "None";
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
            console.log("gettign asn owners")
            var nero = {}
            var i = 0
            for ( i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    //console.log("UPDATETICKER")
                    this.is_asn_owners = false
                    this.$nextTick(() => {
                        // Add the component back in
                        this.is_asn_owners = true;
                    });
                    this.table_buffer = false;
                    this.$nextTick(() => {
                        // Add the component back in
                        this.table_buffer = true;
                    });
                }
            }
        },
        asnNuserINfo: async function (refresh) {
            if (refresh) {
                console.log(refresh)
            }
            this.loading = true;
            this.data = [];
            var dd = Math.floor((new Date() / 1000) - this.hoursback * 3600);
//            console.log(this.$store.state.allASNInfoForOrg);
//            console.log("THIS INFORMATION IS THE ");
            try {
                if (1 == 1) {  
                    var query = `query getuserasn { getASNsForOrg( start_time:` + dd + `)
                        { 
                            asn 
                            asn_name
                            alert_name
                            notification_count 
                            path_change_count
                            first_seen_count
                            ownership_assertion_count
                            own_path_first
                            opf_new
                        }
                    }`;
                    this.$store.state.allASNInfoForOrg = [];
                    const getASNInfo = await API.graphql(graphqlOperation(query));
                    var ASNInformation = getASNInfo.data.getASNsForOrg;
                    this.data=[]
                    for (var i = 0; i < ASNInformation.length; i++) {
                        if (ASNInformation[i].notification_count==null) {
                            ASNInformation[i].notification_count = 0
                        }
                        if ( !(this.asn_get_owner.includes(ASNInformation[i].asn)) ) {
                            this.asn_get_owner.push(ASNInformation[i].asn.toString())
                        }
                        if ( i == ASNInformation.length - 1 ) {
                            this.getASNOwners()
                        }

                        try {
                            ASNInformation[i].show_ownership_assertion=false;
                            ASNInformation[i].show_path_change=false;
                            ASNInformation[i].show_first_seen=false;
                            if (ASNInformation[i].own_path_first != null ) {
                                ASNInformation[i].opf_split = ASNInformation[i].own_path_first.split("")
                                ASNInformation[i].show_ownership_assertion=ASNInformation[i].opf_split[0] == 1 ? true : false;
                                ASNInformation[i].show_path_change=ASNInformation[i].opf_split[1] == 1 ? true : false;
                                ASNInformation[i].show_first_seen=ASNInformation[i].opf_split[2] == 1 ? true : false;
                                if (ASNInformation[i].opf_split[3] == 1) {
                                    ASNInformation[i].show_ownership_assertion=true;
                                    ASNInformation[i].show_path_change=true;
                                    ASNInformation[i].show_first_seen=true;
                                }
                            }
                            if (ASNInformation[i].opf_new != null) {
                                var opf_new=JSON.parse(ASNInformation[i].opf_new);
                                if (opf_new.assertion) {ASNInformation[i].show_ownership_assertion=true;}
                                if (opf_new.pathchange) {ASNInformation[i].show_path_change=true;}
                                if (opf_new.firstseen) {ASNInformation[i].show_first_seen=true;}
                            }


                            
                        //    for ( var j = 0 ; j < ASNInformation[i].opf_split.length ; j++ ) {
                        //        ASNInformation[i].opf_split[j] = ASNInformation[i].opf_split[j] == 1 ? true : false;
                        //    }
                        } catch (e) {
                            console.log(e)
                            ASNInformation[i].opf_split = [false, false, false, false]
                        }
                        if (ASNInformation[i].asn_name=='--') {
                            ASNInformation[i].asn_name=ASNInformation[i].alert_name    
                        }

                        var reqBreDow = {
                            asn: ASNInformation[i].asn,
                            asn_name: ASNInformation[i].asn_name != '' ? ASNInformation[i].asn_name : false,
                            count: ASNInformation[i].notification_count,
                            opf_split: ASNInformation[i].opf_split,
                            show_ownership_assertion: ASNInformation[i].show_ownership_assertion,
                            show_path_change: ASNInformation[i].show_path_change,
                            show_first_seen: ASNInformation[i].show_first_seen,
                            ownership_assertion: ASNInformation[i].ownership_assertion_count,
                            path_change: ASNInformation[i].path_change_count,
                            first_seen: ASNInformation[i].first_seen_count
                        }
                        this.data.push(reqBreDow);
                    }
                    this.$store.state.allASNInfoForOrg = this.data;
                        this.id = this.id + 1;
                        if (this.type == "alert") {
                            this.message = this.organisation + " Alert summaries by ASN"
                        } else if (this.type == "setting") {
                            this.message = "Select ASN to edit threshold scores."
                        }
                } else {
                    this.data = this.$store.state.allASNInfoForOrg;
                    this.id=this.id+1;
                        if (this.type == "alert") {
                            this.message = this.organisation + " Alert summaries by ASN"
                        } else if (this.type == "setting") {
                            this.message = "Select ASN to edit threshold scores."
                        }
                    }
                }
            catch (err) {
                console.log(err)
            }
            this.getEventCounts();
            this.loading = false
        },
        refreshList: async function (n) {
            this.loading = true;
            this.hoursback = n;
            this.getEventCounts();
            this.asnNuserINfo('refresh');
            this.headers[3].text = "Alert Count (" + n + "h)";
            this.headers[2].text = "Event Count (" + n + "h)";
        },
        getAnEventCount: async function (item, dd) {
            try {
                var query =` query getASNEvents { getASNEvents (
                        asn: "`+item.asn+`", 
                        start_time: ` + dd + `) {
                    event_count
                }}`;
                //console.log(query)
                const ASNBaseLine = await API.graphql(graphqlOperation(query));
                var baseLineBreakDown = ASNBaseLine.data.getASNEvents[0];
                //console.log(baseLineBreakDown)
                
                //console.log(item.asn);
                return baseLineBreakDown.event_count;
                
            
            } catch (err) {
                return 0;                
            }
            
        },
        getEventCounts: async function () {
            var d = new Date();
            var day = ("0" + d.getUTCDate()).slice(-2);
            var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
            var year = d.getUTCFullYear()
            var dateFormatted = day + "/" + month + "/" + year
            var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
            this.updatedStr = "U: " + dateFormatted + " " + timeFormatted
            var dd = Math.floor((d.getTime() / 1000) - this.hoursback * 3600);
            // why is it called nero? because it's full of PROMISES ;)
            var nero = [];
            var i=0;
            for (i = 0; i < this.data.length ; i++) {
                nero.push(this.getAnEventCount(this.data[i], dd))
            }
            for (i = 0; i < this.data.length ; i++) {
                
                try {
                    this.data[i].loading = true;
                    this.data[i].event_count = '...';
                    this.data[i].event_count = await nero[i]
                    this.data[i].loading = false;
                    this.loading = true;
                
                    this.$nextTick(() => {
                        // Add the component back in
                        this.loading = false;
                    });
                } catch (err) {
                    this.data[i].event_count = 0;
                    //console.log(err);
                    this.data[i].loading = false;
                }

            }
        }
    },
    watch: {
        showTheBlock (n) {
            this.$store.commit("setShowSettings", { 'showOrgASNSummary': n });
        }
    }
}
</script>

<style scoped>

    table.v-table tbody td, 
    table.v-table tbody th {
        height: 40px;
    }


    .special
    {
        cursor: pointer;
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

</style>